<div matDialogContent>
  <div [formGroup]="detailsForm">
    <div class="row">
      <mat-form-field appearance="outline">
        <mat-label>Name</mat-label>
        <input matInput type="text" formControlName="name" />
      </mat-form-field>
    </div>
    <div class="row">
      <mat-form-field appearance="outline">
        <mat-label>Commission Rate %</mat-label>
        <input matInput type="number" formControlName="commissionRate" />
      </mat-form-field>
    </div>
  </div>

  <mat-list>
    <h3>Linked Accounts:</h3>
    @for (account of linkedAccounts$ | async; track trackById($index, account)) {
      <mat-list-item class="linked-account">
        <span class="linked-account__list-item">
          {{ account.name }}
          <button mat-icon-button color="accent" (click)="removeLink(account.id)">
            <mat-icon svgIcon="delete"></mat-icon>
          </button>
        </span>
      </mat-list-item>
    }
    <mat-list-item class="form-item">
      <div [formGroup]="linkAccountForm">
        <mat-form-field appearance="outline" class="select-field">
          <mat-label>Link Account</mat-label>
          <input
            matInput
            type="text"
            placeholder="Account name"
            formControlName="account"
            [matAutocomplete]="accountAutocomplete"
          />
          @if (hasLinkAccountValue$ | async) {
            <button (click)="resetLinkAccount()" class="clear-field" mat-icon-button matSuffix>
              <mat-icon>close</mat-icon>
            </button>
          }
          <mat-autocomplete #accountAutocomplete="matAutocomplete" [displayWith]="displayAccount">
            @for (account of filteredUnlinkedWallets$ | async; track trackById($index, account)) {
              <mat-option [value]="account.id">
                {{ account.name }}
              </mat-option>
            }
          </mat-autocomplete>
        </mat-form-field>
        <button
          (click)="addLink()"
          [disabled]="linkAccountForm.invalid"
          mat-button
          color="primary"
          class="action-button"
        >
          <mat-icon>link</mat-icon> Link
        </button>
      </div>
    </mat-list-item>
  </mat-list>
</div>
